import {
  IContextBuilder,
  IReferralScopeData,
  IReferralTemplateContext,
} from '@principle-theorem/principle-core/interfaces';
import { NameHelpers } from '../../models/patient/name-helpers';
import { getMissingContextPlaceholder } from '../template-context-resolver';
import { PatientContextBuilder } from './patient-context';

export class ReferralContextBuilder
  implements IContextBuilder<IReferralTemplateContext>
{
  private _patientContextBuilder: PatientContextBuilder;

  constructor(private _data: IReferralScopeData) {
    this._patientContextBuilder = new PatientContextBuilder(this._data);
  }

  build(): IReferralTemplateContext {
    const { referral, referrerAddress, recipientAddress } = this._data;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { referrerName: _referrerName, ...patientContext } =
      this._patientContextBuilder.build();
    return {
      ...patientContext,
      referralReferrerFullName: referral.referrer
        ? NameHelpers.fullName(referral.referrer.name)
        : getMissingContextPlaceholder('referralReferrerFullName'),
      referralReferrerFirstName: referral.referrer
        ? NameHelpers.firstName(referral.referrer.name)
        : getMissingContextPlaceholder('referralReferrerFirstName'),
      referralReferrerAddress:
        referrerAddress ||
        getMissingContextPlaceholder('referralReferrerAddress'),
      referralRecipientFullName: referral.recipient
        ? NameHelpers.fullName(referral.recipient.name)
        : getMissingContextPlaceholder('referralRecipientFullName'),
      referralRecipientFirstName: referral.recipient
        ? NameHelpers.firstName(referral.recipient.name)
        : getMissingContextPlaceholder('referralRecipientFirstName'),
      referralRecipientAddress:
        recipientAddress ||
        getMissingContextPlaceholder('referralRecipientAddress'),
      referralUrgency:
        referral.urgency ?? getMissingContextPlaceholder('referralUrgency'),
      referralType:
        referral.type ?? getMissingContextPlaceholder('referralType'),
      referralStatus:
        referral.status ?? getMissingContextPlaceholder('referralStatus'),
    };
  }
}
